export default "__VITE_ASSET__DFY3dSjH__"